import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { IServiceOrderResponse } from '../../ui-toolkit/orders/interfaces/IServiceOrderResponse';
import { convertOrderDetailsFromAPIToData } from '../../ui-toolkit/orders/methods/convertApiToData';

export interface IGetOrderByIdProps {
  orderId: string;
}

export const getOrderById = async ({ orderId }: IGetOrderByIdProps) => {
  return APIFactory(baseUrlService.ApiLocation)
    .get<IServiceOrderResponse>(`/timber/api/internal/orders/${orderId}`)
    .then((t) => convertOrderDetailsFromAPIToData(t.data))
    .catch(axiosErrorHandler);
};
